<template>
    <b-card class="mb-5">
        <h3>{{$route.name}}</h3>
        <b-breadcrumb>
            <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <hr>
        <b-row class="mb-2">
            <b-col md="3 mb-2">
                <date-picker v-model="tableFilter.weekly" type="week" format="YYYY-MM-DD" placeholder="Week"></date-picker>
            </b-col>
            <b-col md="3 mb-2">
                <b-form-select v-model="tableFilter.branch" :options="branchList"></b-form-select>
            </b-col>
            <b-col md="3 mb-2">
                <b-form-input v-model="tableFilter.searchName" placeholder="Name"></b-form-input>
            </b-col>
        </b-row>
        <table class="table table-hovered table-striped">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Branch</th>
                    <th class="text-center" v-for="(day, index) in days" :key="index">{{day.name}}</th>
                    <th>Total</th>
                </tr>
            </thead>
            <template v-if="isLoading">
                <tbody>
                    <tr>
                        <td colspan="10" class="text-center"><b-spinner variant="primary" label="Spinning"></b-spinner></td>
                    </tr>
                </tbody>
            </template>
            <template v-else>
                <tbody v-if="weeklyJobReport.length > 0">
                    <tr v-for="(job, index) in weeklyJobReport" :key="index">
                        <td>{{job.name}}</td>
                        <td>{{job.branch}}</td>
                        <td v-for="(day, key) in days" :key="key">
                            <div v-for="(jobDay, keyJob) in job.days" :key="keyJob">
                                <div class="text-center" v-if="day.key === jobDay.day">
                                    {{jobDay.workTime === '00:00' ? '-' : jobDay.workTime}}
                                </div>
                            </div>
                        </td>
                        <td>{{job.total}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <th colspan="10" class="text-center">There's No Data</th>
                    </tr>
                </tbody>
            </template>
        </table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    export default {
        name: 'vehicle-report',
        components: {
            PaginatedTable,
            DatePicker
        },
        data () {
            return {
                dataKey: 'weekly-job-report',
                apiUrl: {
                    weeklyJobReport : window.AppConfig.apiUrl + 'weekly-job-report',
                    branch : window.AppConfig.apiUrl + 'branch'
                },
                days: [
                    {
                        name: 'Sunday',
                        key: 'Sun'
                    },
                    {
                        name: 'Monday',
                        key: 'Mon'
                    },
                    {
                        name: 'Tuesday',
                        key: 'Tue'
                    },
                    {
                        name: 'Wednesday',
                        key: 'Wed'
                    },
                    {
                        name: 'Thursday',
                        key: 'Thu'
                    },
                    {
                        name: 'Friday',
                        key: 'Fri'
                    },
                    {
                        name: 'Saturday',
                        key: 'Sat'
                    }
                ],
                branchList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ],
                isLoading: false,
                weeklyJobReport: [],
                tableFilter: {
                    weekly: null,
                    branch: null,
                    searchName: null
                }
            }
        },
        mounted() {
            this.getWeeklyJobReport()
            this.getBranch()
        },
        watch: {
            'tableFilter.weekly' () {
                this.getWeeklyJobReport()
            },
            'tableFilter.branch' () {
                this.getWeeklyJobReport()
            },
            'tableFilter.searchName' () {
                this.getWeeklyJobReport()
            },
        },
        methods: {
            getWeeklyJobReport () {
                this.isLoading = true
                let url = this.apiUrl.weeklyJobReport + '?acending=1'
                if (this.tableFilter.weekly !== null) {
                    url += '&start_date=' + this.$moment(this.tableFilter.weekly).startOf('week').format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.weekly).endOf('week').format('YYYY-MM-DD')
                }
                if (this.tableFilter.branch !== null) {
                    url += '&branch_uuid=' + this.tableFilter.branch
                }
                if (this.tableFilter.searchName !== null) {
                    url += '&search_name=' + this.tableFilter.searchName
                }
                this.$http.get(url).then(resp => {
                    this.weeklyJobReport = []
                    resp.data.timesheet.forEach(data => {
                        this.weeklyJobReport.push(data)
                    })
                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getBranch () {
                this.$http.get(this.apiUrl.branch + '?limit=500').then(resp => {
                    resp.data._embedded.branch.forEach(data => {
                        this.branchList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            doFilter () {
                // this.$refs.dataTable.doFilter(this.tableFilter)
            }
        }
    }
</script>